import { render, staticRenderFns } from "./clientCollapse.vue?vue&type=template&id=776dcbf3&scoped=true&"
import script from "./clientCollapse.vue?vue&type=script&lang=js&"
export * from "./clientCollapse.vue?vue&type=script&lang=js&"
import style0 from "./clientCollapse.vue?vue&type=style&index=0&id=776dcbf3&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776dcbf3",
  null
  
)

export default component.exports